import { category as categoryApi } from "src/api/index";
export function useCategories({ searchCategories }) {
  const categories = ref(new Set());

  const fetchCategories = async () => {
    const categoryResponse = await categoryApi.index({
      params: {
        search: searchCategories.join(","),
        isSubCategory: 0,
      },
    });

    const categoryData = categoryResponse?.data?.data?.data || [];

    categories.value = new Set(
      categoryData
        .filter((category) => searchCategories.includes(category.name))
        .map((category) => category._id),
    );
  };

  return {
    fetchCategories,
    categories,
  };
}
